/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DemandDto } from '../models/DemandDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DemandControllerService {
    /**
     * @param uuid
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<DemandDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: DemandDto,
    ): CancelablePromise<DemandDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/demands/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/demands/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands',
        });
    }
    /**
     * @param requestBody
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: DemandDto,
    ): CancelablePromise<DemandDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/demands',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param status
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByStatus(
        status: 'ACTIVE' | 'FULFILLED' | 'CANCELLED',
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/status/{status}',
            path: {
                'status': status,
            },
        });
    }
    /**
     * @param minPriority
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByPriority(
        minPriority: number,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/priority',
            query: {
                'minPriority': minPriority,
            },
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getOpenDemands(
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/open',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * @param materialUuid
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByMaterial(
        materialUuid: string,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/material/{materialUuid}',
            path: {
                'materialUuid': materialUuid,
            },
        });
    }
    /**
     * @param demandType
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByDemandType(
        demandType: 'ORDER' | 'FORECAST',
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/demand-type/{demandType}',
            path: {
                'demandType': demandType,
            },
        });
    }
    /**
     * @param demandDate
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByDate(
        demandDate: string,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/date/{demandDate}',
            path: {
                'demandDate': demandDate,
            },
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByDateRange(
        startDate: string,
        endDate: string,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * @param customerOrderNumber
     * @returns DemandDto OK
     * @throws ApiError
     */
    public static getDemandsByCustomerOrder(
        customerOrderNumber: string,
    ): CancelablePromise<Array<DemandDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/demands/customer-order/{customerOrderNumber}',
            path: {
                'customerOrderNumber': customerOrderNumber,
            },
        });
    }
}
